module.exports = __webpack_public_path__ + "img/flame.268df099.svg";